import observeNewsImpression from '@/common/news_impression_observer.js'

if (typeof window.observeNewsImpression !== 'function') {
  observeNewsImpression(window.observeNewsImpression)
}
window.observeNewsImpression = observeNewsImpression
